var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("d2-container-frame", {
    attrs: { src: "https://d2.pub/zh/doc/d2-admin" }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }